import { SELECTABLE_BOT_CATALOG, type GamePlayerResponse } from '@warcarp/api-types'

/**
 * Returns the selectable catalog with the per-game availability state used by the
 * host's Add Bot picker. Legacy bot rows have a null profile and therefore do
 * not consume a stable catalog identity.
 */
export function botPickerOptions(
  players: Pick<GamePlayerResponse, 'botProfile'>[],
) {
  const usedProfiles = new Set(
    players.flatMap((player) => player.botProfile ? [player.botProfile] : []),
  )

  return SELECTABLE_BOT_CATALOG.map((bot) => ({
    ...bot,
    alreadyInGame: usedProfiles.has(bot.key),
  }))
}

/**
 * Choose distinct available stable bots for a one-tap lobby fill. Supplying
 * `random` keeps the shuffle deterministic in tests without weakening the
 * production behavior.
 */
export function randomBotProfilesForSeats(
  players: Pick<GamePlayerResponse, 'botProfile'>[],
  seatCount: number,
  random: () => number = Math.random,
): string[] {
  const available = botPickerOptions(players)
    .filter((bot) => !bot.alreadyInGame)
    .map((bot) => bot.key)

  for (let index = available.length - 1; index > 0; index--) {
    const swapIndex = Math.min(index, Math.floor(random() * (index + 1)))
    ;[available[index], available[swapIndex]] = [available[swapIndex]!, available[index]!]
  }

  return available.slice(0, Math.max(0, seatCount))
}
